function loadView(path) {
    if (process.env.NODE_ENV === 'development') {
        return () => import( /* webpackChunkName: "page-[request]" */ `@/pages/${path}.vue`)
    } else {
        return () => import(`@/pages/${path}.vue`)
    }
}

export default {
    mode: 'history',
    scrollBehavior() {
        return {
            x: 0,
            y: 0
        }
    },
    routes: [{
        path: "/",
        name: "index",
        component: loadView('infopage/index'),
    }, {
        path: "/infopage",
        component: loadView('infopage/index'),
        name: 'infopage',
    }, {
        path: "/infopage/companies",
        component: loadView('infopage/components/Companies'),
        name: 'infopage.companies'
    }, {
        path: "/infopage/native-speakers",
        component: loadView('infopage/components/Speakers'),
        name: 'infopage.native-speakers'
    }, {
        path: "/infopage/contacts",
        component: loadView('infopage/components/Contacts'),
        name: 'infopage.contacts'
    }, {
        path: "/infopage/privacy",
        component: loadView('infopage/components/Privacy'),
        name: 'infopage.privacy'
    }, {
        path: "/infopage/terms",
        component: loadView('infopage/components/Terms'),
        name: 'infopage.terms'
    }, {
        path: "/infopage/password-recovery",
        component: loadView('infopage/components/NewPassword'),
        name: 'infopage.password-recovery'
    }, {
        path: "/login",
        name: "login",
        component: loadView('login/index'),
    }, {
        path: "/dashboard",
        component: loadView('dashboard/index'),
        name: "dashboard",
    }, {
        path: '/education',
        name: 'education',
        redirect: '/education/categories'
    }, {
        path: '/education/categories',
        component: loadView('education/index'),
        children: [{
            path: ':id',
            component: loadView('education/categories/index'),
            name: 'education.category'
        }, {
            path: 'attestation',
            redirect: '/education/attestation'
        }, {
            path: 'attestation/:id',
            component: loadView('attestation/_id/index'),
            name: 'attestation'
        }]
    },
    {
        path: '/education/attestation/:id/active',
        component: loadView('attestation/_id/active'),
        name: "attestation.active"
    },
    {
      path: '/education/categories/:id/:courseId/learning',
      component: loadView('education/categories/course/index'),
      children: [{
          path: '/',
          component: loadView('education/categories/course/id/index'),
          name: 'education.course.learning'
        },
        {
          path: 'test',
          component: loadView('education/categories/course/test/index'),
          name: 'education.course.learning.test'
        },
      ]
    },
    {
      path: '/education/categories/:id/exam',
      component: loadView('education/categories/course/exam/index'),
      name: 'education.course.exam'
    },
    {
        path: '/education/good-calls',
        component: loadView('education/good-calls'),
        name: 'education.good-calls'
    },
    {
      path: "/calling-list",
      name: "calling-list",
      component: loadView('calling-list/index'),
    },
    {
      path: "/statistic",
      name: "statistic",
      component: loadView('statistic/index'),
    },
    {
        path: "/product-stat",
        name: "product-stat",
        component: loadView('product-stat/index'),
    },
    {
      path: "/order",
      name: "order",
      component: loadView('order/index'),
      children: [{
          path: "edit",
          name: 'order.edit',
          component: loadView('order/edit'),
          meta: {
            showSidebar: true
          }
        },
        {
          path: "/order/recall",
          name: "order.recall",
          component: loadView('order/recalls')
        },
      ]
    },
    {
      path: "/get-iframe",
      component: loadView('get-iframe/index'),
      name: 'get-iframe',
    },
    {
      path: "/iframe/:id",
      component: loadView('iframe/index'),
      name: 'iframe',
    },
    {
      path: "/genesys/:id",
      component: loadView('iframe/index'),
      name: 'genesys',
    },
    {
      path: "/calculator",
      name: "calculator",
      component: loadView('calculator'),
    },
    {
      path: "/rating",
      name: "rating",
      component: loadView('rating'),
    },
    {
      path: "/create-order",
      component: loadView('create-order/index'),
      name: 'create-order',
    },
    // {
    //   path: "/notifications",
    //   name: "notifications",
    //   component: loadView('notifications')
    // },
    // {
    //   path: "/tickets",
    //   component: loadView('tickets/index'),
    //   children: [{
    //     path: "/",
    //     name: 'tickets',
    //     components: {
    //       default: loadView('tickets/list'),
    //       title: loadView('tickets/titles/list')
    //     },
    //   }, {
    //     path: 'create',
    //     name: 'tickets.create',
    //     components: {
    //       default: loadView('tickets/create'),
    //       title: loadView('tickets/titles/create')
    //     },
    //   }, {
    //     path: ':id',
    //     name: 'tickets.details',
    //     props: true,
    //     component: loadView('tickets/details'),
    //     meta: {
    //       emptyLayout: true
    //     }
    //   }]
    // },
    {
      path: '/operator-error',
      name: 'operator-error',
      component: loadView('operator-error/index')
    },
    {
      path: '/operator-error/:operator',
      name: 'operator-error',
      component: loadView('operator-error/index')
    },
    {
      path: '*',
      name: '404',
      component: loadView('404')
    },
    {
        path: "/calling-list-general",
        name: "calling-list-general",
        component: loadView('calling-list-general/index'),
    },
  ]
};